var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"quickitchen"}},[_c('Navbar'),_vm._v(" "),_c('RecipeList',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isRecipeOpen),expression:"!isRecipeOpen"}]}),_vm._v(" "),_c('RecipeModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRecipeOpen),expression:"isRecipeOpen"}]}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a093fc2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/QuicKitchen.vue
// module id = 81
// module chunks = 0